/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../html-utils/url.pipe';
import * as import3 from '@angular/platform-browser';
import * as import4 from '../../html-utils/html.pipe';
import * as import5 from '../../html-utils/css-var.directive';
import * as import6 from './logo.component';
import * as import7 from '../../ordering-context/ordering-context.model';
const styles_LogoComponent:any[] = ([] as any[]);
export const RenderType_LogoComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LogoComponent,
  data: {}
}
);
function View_LogoComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'logo-media-object'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),0),('data:image;base64,' + co.orderingContextModel.verticalLogoImage)));
    ck(v,0,0,currVal_0);
  });
}
function View_LogoComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'logo-media-object'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),1),co.orderingContextModel.verticalLogoImageSvg));
    ck(v,0,0,currVal_0);
  });
}
function View_LogoComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.orderingContextModel.verticalLogoImageSvg && co.orderingContextModel.verticalLogoImage);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.orderingContextModel.verticalLogoImageSvg;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_LogoComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'logo-media-object'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),0),('data:image;base64,' + co.orderingContextModel.horizontalLogoImage)));
    ck(v,0,0,currVal_0);
  });
}
function View_LogoComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'logo-media-object'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),1),co.orderingContextModel.horizontalLogoImageSvg));
    ck(v,0,0,currVal_0);
  });
}
function View_LogoComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.orderingContextModel.horizontalLogoImageSvg && co.orderingContextModel.horizontalLogoImage);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.orderingContextModel.horizontalLogoImageSvg;
    ck(v,6,0,currVal_1);
  },(null as any));
}
export function View_LogoComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import2.UrlPipe,[import3.DomSanitizer]),
    import0.ɵpid(0,import4.HtmlPipe,[import3.DomSanitizer]),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'logo-media'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'vertical',
      'horizontal'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import5.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--woa-horizontal-logo-height',
      '--woa-vertical-logo-width'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LogoComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.LogoComponent = v.component;
    const currVal_0:any = 'logo-media';
    const currVal_1:any = ck(v,4,0,(co.type === 'vertical'),(co.type === 'horizontal'));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,6,0,co.px(co.orderingContextModel.horizontalLogoHeightPx),co.px(co.orderingContextModel.verticalLogoWidthPx));
    ck(v,5,0,currVal_2);
    const currVal_3:any = co.showVerticalLogo();
    ck(v,9,0,currVal_3);
    const currVal_4:any = co.showHorizontalLogo();
    ck(v,12,0,currVal_4);
  },(null as any));
}
function View_LogoComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),View_LogoComponent_0,RenderType_LogoComponent)),
    import0.ɵdid(49152,(null as any),0,import6.LogoComponent,[import7.OrderingContextModel],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const LogoComponentNgFactory:import0.ComponentFactory<import6.LogoComponent> = import0.ɵccf('woa-logo',import6.LogoComponent,View_LogoComponent_Host_0,{type: 'type'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ui-elements/logo/logo.component.ngfactory.ts